<template>
  <gmap-map
    class="google-map"
    v-bind:center="coordinates"
    v-bind:zoom="zoom"
    v-bind:options="mapOptions"
  >
    <gmap-info-window
      v-bind:position="coordinates"
      v-bind:opened="isInfoWindowOpen"
      v-bind:options="infoWindowOptions"
      v-on:closeclick="isInfoWindowOpen=false"
    >
      <div class="google-map-info-window">
        <p>Ювелирная фирма "Стиль"</p>
        <p>Брест, ул. Сябровская 51А</p>
      </div>
    </gmap-info-window>
    <gmap-marker
      v-bind:position="coordinates"
      v-bind:animation="google && google.maps.Animation.DROP"
      v-bind:clickable="true"
      v-on:click="isInfoWindowOpen=!isInfoWindowOpen"
      title="stylegold.by"
    ></gmap-marker>
  </gmap-map>
</template>

<script>
import {gmapApi} from 'vue2-google-maps'
import mapStyles from './contacts-google-map/ContactsGoogleMapStyles.json'

export default {
  name: 'ContactsGoogleMap',
  data () {
    return {
      coordinates: {
        lat: 52.06398,
        lng: 23.73315
      },
      zoom: 15,
      mapOptions: {
        styles: mapStyles
      },
      isInfoWindowOpen: true,
      infoWindowOptions: {
        // offset info window so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35
        }
      }
    }
  },
  computed: {
    google: gmapApi
  }
}
</script>

<style scoped lang="scss">
  $mobile-breakpoint: map-get($media-breakpoints, "mobile");

  .google-map {
    margin: 0 auto;
    width: 100%;
    height: 60vh;
    @media (max-height: $mobile-breakpoint) {
      height: calc(100vh - #{$the-header-main-height});
    }
    @media only print and (orientation: portrait) {
      height: 33vh;
    }

    .google-map-info-window {
      color: black;
      p {
        margin: 0;
        &:first-child {
          font-weight: bolder;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/ContactsGoogleMap.vue